import React, { useMemo } from 'react';
import { PartidaLite } from '../../../../services/faseGrupoPartidasService';
import dayjs from 'dayjs';
import MatchSetsResult from '../../../../components/match/MatchSetsResult';
import { atletasDoLado } from '../../../../utils/atletasDoLado';

interface MatchesTableProps {
  partidas: PartidaLite[];
  onEdit: (partidaId: string) => void;
  canManage?: boolean;
}

const MatchesTable: React.FC<MatchesTableProps> = ({
  partidas,
  onEdit,
  canManage = true,
}) => {
  const partidasOrdenadas = useMemo(() => {
    return [...partidas].sort((a, b) => {
      if (a.numeroPartida && b.numeroPartida) {
        return a.numeroPartida - b.numeroPartida;
      }
      if (a.numeroPartida) return -1;
      if (b.numeroPartida) return 1;
      return new Date(a.criadoEm).getTime() - new Date(b.criadoEm).getTime();
    });
  }, [partidas]);


  const formatDataHora = (data: string): string => {
    if (!data) return 'Não definido';
    const date = dayjs(data);
    if (!date.isValid()) return 'Não definido';
    return date.format('DD/MM/YYYY HH:mm');
  };

  if (partidasOrdenadas.length === 0) {
    return (
      <div className="alert alert-info">
        <p className="mb-0">Nenhuma partida neste grupo.</p>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-striped table-hover">
        <thead className="table-light">
          <tr>
            <th style={{ width: '60px' }}>#</th>
            <th>Data/Hora</th>
            <th>Local</th>
            <th>Equipe A</th>
            <th>Equipe B</th>
            <th style={{ width: '100px' }}>Resultado</th>
            {canManage && <th style={{ width: '80px' }}>Ações</th>}
          </tr>
        </thead>
        <tbody>
          {partidasOrdenadas.map((partida) => (
            <tr key={partida.id}>
              <td className="fw-bold">
                {partida.numeroPartida || '-'}
              </td>
              <td>{formatDataHora(partida.data)}</td>
              <td>{partida.local?.nome || 'Não definido'}</td>
              <td>
                {(() => {
                  const atletas = atletasDoLado(partida, 'A');
                  return atletas.length > 0 ? (
                    <div>
                      {atletas.map((atleta) => (
                        <div key={atleta.id} className="d-flex align-items-center mb-1">
                          <img
                            src={atleta.imagemUrl || '/assets/images/user.png'}
                            alt={atleta.nome}
                            className="rounded-circle me-2"
                            style={{ width: '24px', height: '24px', objectFit: 'cover' }}
                          />
                          <span style={{ fontSize: '14px' }}>{atleta.nome}</span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <span className="text-muted">Não definido</span>
                  );
                })()}
              </td>
              <td>
                {(() => {
                  const atletas = atletasDoLado(partida, 'B');
                  return atletas.length > 0 ? (
                    <div>
                      {atletas.map((atleta) => (
                        <div key={atleta.id} className="d-flex align-items-center mb-1">
                          <img
                            src={atleta.imagemUrl || '/assets/images/user.png'}
                            alt={atleta.nome}
                            className="rounded-circle me-2"
                            style={{ width: '24px', height: '24px', objectFit: 'cover' }}
                          />
                          <span style={{ fontSize: '14px' }}>{atleta.nome}</span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <span className="text-muted">Não definido</span>
                  );
                })()}
              </td>
              <td>
                <MatchSetsResult
                  placar={partida.placar}
                  equipeAWO={partida.equipeAWO}
                  equipeBWO={partida.equipeBWO}
                  equipeADesistencia={partida.equipeADesistencia}
                  equipeBDesistencia={partida.equipeBDesistencia}
                  useMaterialUI={false}
                />
              </td>
              {canManage && (
                <td>
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => onEdit(partida.id)}
                    title="Editar"
                  >
                    <i className="bi bi-pencil"></i>
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MatchesTable;

